import styled from 'styled-components';
export const SectionContainer = styled.section `
  padding: 60px 20px;
  background: #ffffff;
  width: 100%;
`;
export const Container = styled.div `
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  padding: 0 20px;
`;
export const SectionHeader = styled.div `
  text-align: center;
  margin-bottom: 4rem;
`;
export const SectionTitle = styled.h2 `
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  position: relative;
  display: inline-block;
  margin: 0;
  color: #1a1a1a;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: #ffd700;
    border-radius: 2px;
  }
`;
export const WordCloudContainer = styled.div `
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 0;
  position: relative;
`;
export const WordCloud = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
`;
export const SkillTag = styled.span `
  display: inline-block;
  padding: 0.625rem 1.25rem;
  border-radius: 50px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  transform: ${(props) => (props.$visible ? 'translateY(0)' : 'translateY(20px)')};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 2px solid transparent;
  transition: ${(props) => props.$visible
    ? `opacity 0.6s ease-out ${props.$index * 0.03}s, transform 0.6s ease-out ${props.$index * 0.03}s, box-shadow 0.15s ease-out, background 0.15s ease-out`
    : 'opacity 0.6s ease-out, transform 0.6s ease-out'};
  will-change: transform, opacity;

  /* Size variations */
  ${(props) => {
    const sizes = {
        xl: 'font-size: 2.75rem; padding: 1.25rem 2.25rem; font-weight: 800;',
        lg: 'font-size: 2rem; padding: 1rem 1.75rem; font-weight: 700;',
        md: 'font-size: 1.375rem; padding: 0.75rem 1.375rem; font-weight: 600;',
        sm: 'font-size: 1rem; padding: 0.5rem 1rem; font-weight: 600;',
    };
    return sizes[props.$size];
}}

  /* Category colors */
  ${(props) => {
    const categoryColors = {
        framework: `
        background: linear-gradient(135deg, #FFD700 0%, #FDB927 50%, #FFA500 100%);
        color: #1A1A1A;
        border-color: rgba(255, 215, 0, 0.3);

        &:hover {
          background: linear-gradient(135deg, #FFE135 0%, #FFD700 50%, #FFC107 100%);
          box-shadow: 0 12px 24px rgba(255, 215, 0, 0.4);
        }
      `,
        language: `
        background: linear-gradient(135deg, #3B82F6 0%, #2563EB 50%, #1D4ED8 100%);
        color: #FFFFFF;
        border-color: rgba(59, 130, 246, 0.3);

        &:hover {
          background: linear-gradient(135deg, #60A5FA 0%, #3B82F6 50%, #2563EB 100%);
          box-shadow: 0 12px 24px rgba(59, 130, 246, 0.4);
        }
      `,
        tool: `
        background: linear-gradient(135deg, #8B5CF6 0%, #7C3AED 50%, #6D28D9 100%);
        color: #FFFFFF;
        border-color: rgba(139, 92, 246, 0.3);

        &:hover {
          background: linear-gradient(135deg, #A78BFA 0%, #8B5CF6 50%, #7C3AED 100%);
          box-shadow: 0 12px 24px rgba(139, 92, 246, 0.4);
        }
      `,
        styling: `
        background: linear-gradient(135deg, #10B981 0%, #059669 50%, #047857 100%);
        color: #FFFFFF;
        border-color: rgba(16, 185, 129, 0.3);

        &:hover {
          background: linear-gradient(135deg, #34D399 0%, #10B981 50%, #059669 100%);
          box-shadow: 0 12px 24px rgba(16, 185, 129, 0.4);
        }
      `,
        state: `
        background: linear-gradient(135deg, #F97316 0%, #EA580C 50%, #DC2626 100%);
        color: #FFFFFF;
        border-color: rgba(249, 115, 22, 0.3);

        &:hover {
          background: linear-gradient(135deg, #FB923C 0%, #F97316 50%, #EA580C 100%);
          box-shadow: 0 12px 24px rgba(249, 115, 22, 0.4);
        }
      `,
        testing: `
        background: linear-gradient(135deg, #14B8A6 0%, #0D9488 50%, #0F766E 100%);
        color: #FFFFFF;
        border-color: rgba(20, 184, 166, 0.3);

        &:hover {
          background: linear-gradient(135deg, #5EEAD4 0%, #14B8A6 50%, #0D9488 100%);
          box-shadow: 0 12px 24px rgba(20, 184, 166, 0.4);
        }
      `,
    };
    return categoryColors[props.$category] || '';
}}

  &:hover {
    transform: translateY(-6px) scale(1.08);
    z-index: 10;
  }

  @media (max-width: 768px) {
    ${(props) => {
    const mobileSizes = {
        xl: 'font-size: 2rem; padding: 1rem 1.75rem;',
        lg: 'font-size: 1.625rem; padding: 0.875rem 1.5rem;',
        md: 'font-size: 1.25rem; padding: 0.625rem 1.125rem;',
        sm: 'font-size: 0.9375rem; padding: 0.5rem 0.875rem;',
    };
    return mobileSizes[props.$size];
}}
  }
`;
